import PromiseButtonBase from './PromiseButtonBase'

export default PromiseButtonBase
